import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { AudienceRole, AudienceRoleReadModel } from '../../authentication/audience-role';
import { Settings } from '../../core/settings';

@Injectable()
export class AudienceRolesStorage {
    private readonly allAudienceRoles: Observable<AudienceRole[]>;

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings
    ) { 
        this.allAudienceRoles = this.loadAudienceRoles()
            .pipe(
                publishLast(),
                refCount()
            );
    }

    public get all(): Observable<AudienceRole[]> {
        return this.allAudienceRoles;
    }

    public get external(): Observable<AudienceRole[]> {
        return this.all.pipe(map(r => r.filter(role => role.isExternal)));
    }

    private loadAudienceRoles(): Observable<AudienceRole[]> {
        return this.http.get(`${this.settings.apiUrl}/admin/audience-roles`)
            .pipe(map(response => deserialize(response, AudienceRoleReadModel).audienceRoles));
    }
}